import createReducer from 'helpers/reducers-helper';
import { useReducer, useCallback } from 'react';
import constate from 'constate';
import repo from 'service/repository';
import assign from 'lodash/assign';
import appLoader from 'distributor/app-loader';

export const PAGE_SIZE = 20;

const FETCH_ORDERS_SUCCESS = 'fetch_orders_success';
const CHANGE_ORDER_TYPE = 'change_order_type';
export const APPEND_ORDERS = 'append_orders';

const useOrders = () => {
  const { configData } = appLoader;
  const { ordersList } = configData;

  const initState = {
    orderType: ordersList[0].key,
    orders: [],
    loading: false,
  };

  const fetchOrderSuccess = (state, payload) =>
    assign({}, state, { orders: payload.data, paging: payload.paging, loading: false });
  const changeOrderType = (state, orderType) => assign({}, state, { orders: [], orderType, loading: true });
  const appendOrders = (state, payload) => {
    return { ...state, paging: payload.paging, orders: state.orders.concat(payload.data) };
  };

  const reducer = createReducer(
    {
      [FETCH_ORDERS_SUCCESS]: fetchOrderSuccess,
      [CHANGE_ORDER_TYPE]: changeOrderType,
      [APPEND_ORDERS]: appendOrders,
    },
    initState,
    true
  );
  const [state, dispatch] = useReducer(reducer, initState);

  const fetchOrders = useCallback(orderType => {
    dispatch({
      type: CHANGE_ORDER_TYPE,
      payload: orderType,
    });
    repo
      .fetchOrders(1, PAGE_SIZE, [orderType])
      .then(data => {
        dispatch({
          type: FETCH_ORDERS_SUCCESS,
          payload: data,
        });
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  return { state, dispatch, fetchOrders };
};

const [OrdersProvider, useOrdersContext] = constate(useOrders);

export { OrdersProvider, useOrdersContext };
